module.exports = __webpack_public_path__ + "static/media/microsoftsql.b64b6c24.svg";